import { prop, pipe } from "ramda";

/**
 * This is a temporary solution until we have been able to feed to environment type to the frontend
 */

export const EnvParams = {
	BASE_URL: 'baseUrl',
	CDN_DFP_URL: 'cdnDfpUrl',
	CLOUDWATCH_REPO: 'cloudWatchRepo'
}

const Environments = {
	Stage: 'Stage',
	Localhost: 'Localhost'
}

const getEnv = (target) => {
	const env = Object.keys(Environments).filter( key => target.toLowerCase().indexOf(key.toLowerCase()) !== -1);
	return env[0] || undefined
}

const getEnvConfig = (env = 'Prod') => {
	let config;

    switch (env) {
		case Environments.Stage:
			config = {
				cloudWatchRepo: 'se-ads-microservice-stage',
				baseUrl: 'https://se-ads-microservice-stage.ads.allermedia.io/api/v1',
				cdnDfpUrl: 'https://cdn-dev.allermedia.se/se-aller-ads/stage'				
			}
			break;
		case Environments.Localhost:
			config = {
				cloudWatchRepo: 'se-ads-microservice-stage',
				baseUrl: 'http://localhost:1337/api/v1',
				cdnDfpUrl: 'https://cdn-dev.allermedia.se/se-aller-ads/stage'				
			}
			break;
		default:
			config = {
				cloudWatchRepo: 'se-ads-microservice-prod',
				baseUrl: 'https://se-ads-microservice.ads.allermedia.io/api/v1',
				cdnDfpUrl: 'https://cdn.allermedia.se/se-aller-ads/prod'
			}
	}
	return config;
}

const getEnvParam = key => pipe(getEnv, getEnvConfig, prop(key))(window.location.hostname);

export const getProdParam = () => getEnvConfig('Prod');

export const isProd = () => {
    const env = getEnv(window.location.hostname);
    return env !== Environments.Stage && env !== Environments.Localhost
}

export default getEnvParam;